import type { RadarConfig } from "../types/client-config";

export const resolveDefaultRadar = (
  radars: RadarConfig[],
  defaultRadarId?: string
): RadarConfig | undefined => {
  if (defaultRadarId) {
    const match = radars.find((radar) => radar.id === defaultRadarId);
    if (match?.convertedCourseData) {
      return match;
    }
  }
  return (
    radars.find((radar) => radar.enabled && radar.convertedCourseData) ??
    radars[0]
  );
};
